export const BUTTON_VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  LINK: "link",
  DANGER: "danger",
};

export const BUTTON_TYPES = {
  BUTTON: "button",
  LINK: "link",
};

export const BUTTON_SIZES = {
  SMALL: "small",
  LARGE: "large",
};

export const BUTTON_TARGETS = {
  BLANK: "_blank",
};
